import {Dispatch} from "redux";
import {apiLink} from "@web2/ap-api-routes";
import {catch400, catch404} from "@web2/ap-request";
import {createRequestActionTypes} from "@web2/ap-request-state";

import {getAuthorizedRequest} from "../../app/utils/authorized_request";

export const USER_INFO_FETCH = "user-info/FETCH";
export const fetchUserInfoActionTypes = createRequestActionTypes(USER_INFO_FETCH);

export const fetchUserInfo = () => async (dispatch: Dispatch) => {
    dispatch({type: fetchUserInfoActionTypes.start});

    return getAuthorizedRequest(apiLink.account.me({})(null))
        .then((response) => {
            dispatch({type: fetchUserInfoActionTypes.success, result: response});

            return response;
        })
        .catch(
            catch400((responseError) => {
                dispatch({type: fetchUserInfoActionTypes.error, error: responseError.appError});
            })
        )
        .catch(
            catch404((responseError) => {
                dispatch({type: fetchUserInfoActionTypes.error});
            })
        );
};
